import { ConfigProvider, App as AntApp } from 'antd';
import { useRoutes } from 'react-router-dom';
import dayjs from 'dayjs';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';

import { useLayoutStore } from '@/store/layout';
import routes from '@/router';
import { SocketProvider, ErrorBoundary } from '@/components';

dayjs.locale('zh-cn');

const App: React.FC = () => {
    const { config } = useLayoutStore();
    const element = useRoutes(routes);

    return (
        <ConfigProvider locale={zhCN} {...config}>
            <AntApp>
                <ErrorBoundary>
                    <SocketProvider autoConnect showNotifications>
                        {element}
                    </SocketProvider>
                </ErrorBoundary>
            </AntApp>
        </ConfigProvider>
    );
};

export default App;
